<template>
  <div>
    <el-image src="static/img/images08.png" class="el-image-head"/>
    <div class="div-content">
      <div class="div-content-title">
        <label class="label-title">产品中心</label>
        <el-dropdown split-button class="dropdown-menu"
                     @command="handleCommand">
          {{products[index].name}}
          <el-dropdown-menu>
            <el-dropdown-item :command="item.id" v-for="(item) in products" v-bind:key="item.name">{{item.name}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="div-products-img">
      <img :src="products[index].img" class="image-products" alt=""/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Product',
  data () {
    return {
      index: 0,
      products: [
        {id: 0, name: 'A7  系列产品', img: 'static/img/a7.png'},
        {id: 1, name: 'A9  系列产品', img: 'static/img/a9.png'},
        {id: 2, name: 'A15 系列产品', img: 'static/img/a15.png'}
      ]
    }
  },
  activated () {
    this.index = 0
  },
  methods: {
    handleCommand (command) {
      this.index = command
      this.focus()
    }
  }
}
</script>

<style scoped>
.el-image-head{
  height: 541px;
  width: 100%;
}
.div-content{
  width: 60%;
  margin-top: 80px;
  margin-left: 20%;
}
.label-title{
  font-size: 26px;
  color: #FFB400;
  padding-bottom: 20px;
}
.dropdown-menu{
  float: right;
  color: white;
  border: 1px solid  black;
}
.image-products{

}
.div-products-img{
  overflow-x: hidden !important;
  width: 100%;
  min-height: 800px;
}
</style>



// WEBPACK FOOTER //
// src/components/Product.vue